import * as React from "react";

import {
  AppBar,
  AppBarSection,
  AppBarSpacer
} from "@progress/kendo-react-layout";

import DrawerMenuButton from "./DrawerMenuButton";

export default function NavTop() {
  return (
    <AppBar themeColor="inverse" positionMode="fixed">
      <AppBarSection>
        <DrawerMenuButton />
      </AppBarSection>
      <AppBarSpacer style={{ width: 4 }} />
      <AppBarSection>
        <a title="" className="navbar-brand wib-navbar-logo" />
      </AppBarSection>
      <AppBarSpacer />
      <AppBarSection>
        <a className="k-link" href={process.env.WIB_PORTAL_URL}>
          Portal
        </a>
      </AppBarSection>
    </AppBar>
  );
}
